var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('datatable',{attrs:{"title":"Admins","unique_buttons":_vm.unique_buttons,"fields":_vm.fields,"response":_vm.admins},on:{"delete":_vm.deleteAdmin,"create":_vm.createAdmin,"edit_click":_vm.editClick,"set_active_list":_vm.setActiveList,"set_expired_list":_vm.setExpiredList,"set_blocked_list":_vm.setBlockedList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }